import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GroupActivityButton from "../groups/ui/GroupActivityButton";
import { AiOutlineRightCircle } from "react-icons/ai";
import { twoDigitNumber } from "../../Utils/Helper";

function CounterChip({ bgcolor, title, data, icon, link, currentDate }) {

const [calFilter, setCalFilter] = useState()
const navigate = useNavigate()

  useEffect(()=>{
    setCalFilter(currentDate)
  },[currentDate])

  return (
    <div
      style={{
        height: "150px",
        width: "300px",

        backgroundColor: bgcolor,
        title: { title },
        color: "white",
        borderRadius: "20px",
        border: "none",
        boxShadow: " 0px 4px 14px 0px rgba(0, 0, 0, 0.5)",
      }}
      className="fw-semibold px-2 py-1 d-flex justify-content-start align-items-start position-relative pointer"
      onClick={() => navigate(link, {state:{date:calFilter}} )}
    >
      <div className="row justify-content-start align-items-center h-100 w-100">
        <div className="col-md-6 col-lg-5 col-sm-6">
          <div
            style={{
              borderRadius: "50%",
              width: "80%",
              height: "100%",
              maxHeight: "65px",
              maxWidth: "65px",
              backgroundColor: "rgba(255,255,255,0.4)",
            }}
            className="d-flex ms-lg-2 align-items-center justify-content-center p-lg-2 p-md-1 p-sm-1"
          >
            <img src={icon} alt="" className="img-fluid" />
          </div>
        </div>
        <div className="col-md-6 col-lg-7 col-sm-6">
          <h3 className="fw-normal chidHeadFont">
            {data?.length > 0 ? twoDigitNumber(data?.length) || data : "--"}
          </h3>
          <span className="w-100 resFont">{title}</span>
        </div>
      </div>
      <div className="d-flex position-absolute top-0 end-0  align-items-start mt-2">
        <Link
          className="pointer text-decoration-none text-white"
          to={link}
          state= {{date: calFilter}}
        >
          <GroupActivityButton className="py-1 btn" color="white" border="none">
            <AiOutlineRightCircle size={"35px"} />
          </GroupActivityButton>
        </Link>
      </div>
    </div>
  );
}

export default CounterChip;
